import { DEV_PACKAGE_TIER_STORAGE_KEY, PACKAGE_TIERS } from "./constants";

/**
 * @param {unknown} value
 * @returns {value is import("./constants").PackageTier}
 */
export function isValidPackageTier(value) {
  return PACKAGE_TIERS.includes(/** @type {any} */ (value));
}

/** @returns {import("./constants").PackageTier|null} */
export function readStoredDevPackageTier() {
  if (typeof localStorage === "undefined") return null;
  try {
    const raw = localStorage.getItem(DEV_PACKAGE_TIER_STORAGE_KEY);
    return isValidPackageTier(raw) ? raw : null;
  } catch {
    return null;
  }
}

/** @param {import("./constants").PackageTier|null} tier */
export function writeStoredDevPackageTier(tier) {
  if (typeof localStorage === "undefined") return;
  try {
    if (tier == null) {
      localStorage.removeItem(DEV_PACKAGE_TIER_STORAGE_KEY);
      return;
    }
    if (!isValidPackageTier(tier)) return;
    localStorage.setItem(DEV_PACKAGE_TIER_STORAGE_KEY, tier);
  } catch {
    /* ignore */
  }
}
